import { FC } from 'react'

import { Button, Tooltip } from '@mui/material'
import { FaInfoCircle } from 'react-icons/fa'

interface IProps {
    hint: string
}

const InfoTooltip: FC<IProps> = ({hint}) => {
  return (
    <Tooltip title={hint} placement='top'>
        <Button onClick={() => {}}
            size='small'
            color='info'
            sx={{
                minWidth: '0px',
                width: 'auto',
            }}
        ><FaInfoCircle /></Button>
    </Tooltip>
  )
}

export default InfoTooltip


